import { EmoticonCryIcon } from './EmoticonCryIcon';

/**
 * author: Michael Irigoyen
 * id 39704938-DF4F-4E60-8C20-0569B4B1819C
 * name emoticon-cry
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-cry.svg
 * tags
 * - Emoji 
 */
export const EmojiCryIcon = EmoticonCryIcon;
export default EmojiCryIcon